import React from 'react';
import PropTypes from 'prop-types';

import DiveMessageBanner from '../../common/DiveMessageBanner';

const MultimediaUploadErrorBanner = ({ error = 'unknown-error', fileName = '', handleBannerClose = () => {} }) => {
  // errorStates keys correspond to the error property of fileRejections
  // in CrosspostCheckoutContainer. This dictionary object allows us to customize
  // the copy displayed in error banners based on error codes output by
  // the Dropzone component, MultimediaForm's uniqueNameValidator(), and
  // CrosspostCheckoutContainer's handleMultimediaUploadError()
  const errorStates = {
    'duplicate-file': {
      title: 'Duplicate file',
      message: 'A file with the specified name already exists. Please rename your file and try again.',
    },
    'file-invalid-type': {
      title: 'File type is not supported',
      message:
        'We could not upload your file because it is not in an acceptable format. Please convert your file to jpg, png, pdf, mp4 or mov.',
    },
    'file-too-large': {
      title: 'File size exceeded',
      message: 'The file is too large and cannot be uploaded. Please reduce the size to 100 MB or less and try again.',
    },
    'server-side-error': {
      title: 'Server side error',
      message: 'File upload failed. Please try again later',
    },
    'invalid-url': {
      title: 'Invalid URL',
      message: 'The link to your video is not in an acceptable format. Please copy the entire video URL.',
    },
    'duplicate-url': {
      title: 'Duplicate Video URL',
      message: 'A video with the specified URL already exists. Please choose a different video.',
    },
    'unknown-error': {
      title: 'Unknown error',
      message: 'File upload failed. Please try again later',
    },
    'too-many-files': {
      title: 'File limit reached',
      message: 'You have reached the maximum number of files that can be uploaded. Please remove a file to upload a new one.',
    },
    'multiple-files': {
      title: 'Multiple files not allowed',
      message: 'Found more than one file in upload. Please upload only one file.',
    },
  };

  return (
    <DiveMessageBanner messageType="error" additionalClasses="upload-error" onClose={() => handleBannerClose(fileName, error)}>
      <p className="upload-error__title">
        {errorStates[error] ? errorStates[error].title : 'Unknown error'}
        {fileName !== '' ? `: ${fileName}` : ''}
      </p>
      <p className="upload-error__message">
        {errorStates[error] ? errorStates[error].message : 'File upload failed. Please try again later'}
      </p>
    </DiveMessageBanner>
  );
};

MultimediaUploadErrorBanner.propTypes = {
  error: PropTypes.string,
  fileName: PropTypes.string,
  handleBannerClose: PropTypes.func,
};

export default MultimediaUploadErrorBanner;
